import { render, staticRenderFns } from "./DrContract.vue?vue&type=template&id=3bdd4188&scoped=true"
import script from "./DrContract.vue?vue&type=script&lang=js"
export * from "./DrContract.vue?vue&type=script&lang=js"
import style0 from "./DrContract.vue?vue&type=style&index=0&id=3bdd4188&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdd4188",
  null
  
)

export default component.exports